import React, {Component, Fragment} from 'react'
import Switch from 'rc-switch'
import autobind from 'auto-bind'

export default class UseRollingCycleTimeTargets extends Component {
    id = 'UseRollingCycleTimeTargets'
    field = 'useRollingCycleTimeTargets'
    constructor(props) {
        super(props)
        autobind(this)

        const initialValue =
            this.props &&
            Object.prototype.hasOwnProperty.call(this.props, 'existing') &&
            this.props.existing !== undefined
                ? this.props.existing
                : false

        this.state = {
            value: initialValue,
        }

        if (this.props && this.props.cb) {
            this.props.cb('useRollingCycleTimeTargets', initialValue)
        }
    }

    handleValueChange(value) {
        this.setState({value})

        if (this.props.cb) {
            this.props.cb('useRollingCycleTimeTargets', value)
        }
    }

    render() {
        return (
            <Fragment>
                <label>
                    Use 30 day rolling cycle time average for targets (requires
                    "Total Cycle Time" state):
                </label>
                <Switch
                    className="custom-switch custom-switch-primary"
                    checked={this.state.value}
                    onChange={this.handleValueChange}
                />
            </Fragment>
        )
    }
}
